module.exports = __webpack_public_path__ + "static/media/book_b150.30c4b925.jpg";